var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "auth-container",
    [
      _c(
        "v-card",
        [
          _c("v-card-text", { staticClass: "mb-3" }, [
            _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "display-3" }, [_vm._v("404")]),
              _vm._v(" "),
              _c("div", { staticClass: "title mb-2" }, [_vm._v("Whoops...")]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle mb-2" }, [
                _vm._v("The page you are looking for was not found.")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        outlined: "",
                        color: "secondary",
                        small: _vm.isMobile
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/home")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        Get me out of here\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }